import React from 'react';
import { CircleCheck } from 'lucide-react';

const EquipmentSelector = ({
  shipmentEquipment,
  selectedEquipment,
  allEquipmentsById = {},
  onSelect,
}) => {
  if (!shipmentEquipment) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {shipmentEquipment.map((eq, index) => {
        const selected = selectedEquipment === eq;
        return (
          <button
            data-testid={`button-9863314a-${index}`}
            onClick={() => onSelect(selected, allEquipmentsById[eq])}
            className={`inline-flex items-center gap-1 px-3 py-2 rounded border text-sm ${
              selected
                ? 'border-green-cm text-green-cm'
                : 'border-gray-400 text-gray-400'
            }`}
            key={eq}
          >
            <span data-testid={`span-fe63be10-${index}`}>{eq}</span>
            {selected && (
              <CircleCheck
                data-testid={`i-caf83b36-${index}`}
                className="h-4 w-4"
              />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default EquipmentSelector;
